// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KBHWLlmmQ29DzJ {
  margin-bottom: var(--ds-space-200, 16px);
  padding-top: var(--ds-space-200, 16px);
}
.KBHWLlmmQ29DzJ.EvjhaXu76s836V {
  padding-top: var(--ds-space-600, 48px);
}
`, ""]);
// Exports
export var page = `KBHWLlmmQ29DzJ`;
export var fullscreen = `EvjhaXu76s836V`;
export default ___CSS_LOADER_EXPORT___;
